export default __webpack_public_path__ + "static/media/mata_atlantica_content.d689e212.jpg";